export const FLAG_NOCACHE = 0x0040;
export const FLAG_NOOPTIMIZE = 0x0100;
export const FLAG_NULLTRANSFORM = 0x0200;

export const FLAG_GAMUTCHECK = 0x1000;

export const FLAG_BLACKPOINTCOMPENSATION = 0x2000;
export const FLAG_NOWHITEONWHITEFIXUP = 0x0004;
export const FLAG_HIGHRESPRECALC = 0x0400;
export const FLAG_LOWRESPRECALC = 0x0800;

export const FLAG_COPYALPHA = 0x04000000;
